var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown", class: _vm.dropdownClasses }, [
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.hasValue,
            expression: "!hasValue"
          }
        ],
        staticClass: "dropdown__placeholder",
        on: { click: _vm.handleClickOnDrop }
      },
      [_vm._v(_vm._s(_vm.placeholder))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropdown__active-value",
        on: { click: _vm.handleClickOnDrop }
      },
      [
        _vm.activeValue.svg
          ? _c("div", {
              staticClass: "dropdown__active-value__svg",
              domProps: { innerHTML: _vm._s(_vm.activeValue.svg) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("span", { domProps: { innerHTML: _vm._s(_vm.activeValue.label) } })
      ]
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "dropdown__arrow",
      class: _vm.svgArrowClasses,
      domProps: { innerHTML: _vm._s("arrow.svg") }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOptionsVisible,
            expression: "isOptionsVisible"
          }
        ],
        staticClass: "dropdown__items",
        class: _vm.itemsClasses
      },
      _vm._l(_vm.options, function(option) {
        return _c(
          "dropdown-item",
          {
            key: option.value,
            attrs: { value: option.value },
            on: { click: _vm.handleUpdate }
          },
          [
            option.svg
              ? _c("div", {
                  staticClass: "dropdown-item__svg",
                  domProps: { innerHTML: _vm._s(option.svg) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(option.label) } })
          ]
        )
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b9365b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b9365b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/dropdown/dropdown.html
// module id = null
// module chunks = 